<template lang="pug">
    .home
        h1 My pixel editor WIP
</template>

<script>
export default {
  name: 'home'
}
</script>
